import { CloserToolbarSelect } from '@/components/CloserLeads/CloserToolbarSelect'
import { GestorTabFiltersBar } from '@/components/Gestores/GestorTabFiltersBar'

type Props = {
  search: string
  onSearchChange: (v: string) => void
  view: 'lista' | 'calendario'
  onViewChange: (v: 'lista' | 'calendario') => void
}

export function GestorEquipeFilters({ search, onSearchChange, view, onViewChange }: Props) {
  const hasActiveFilter = search.trim().length > 0 || view !== 'lista'

  return (
    <GestorTabFiltersBar
      search={search}
      onSearchChange={onSearchChange}
      searchPlaceholder='Buscar profissional PJ…'
      searchAriaLabel='Buscar equipe'
      showClear={hasActiveFilter}
      onClearAll={() => {
        onSearchChange('')
        onViewChange('lista')
      }}
    >
      <CloserToolbarSelect
        value={view}
        onChange={(v) => onViewChange(v as 'lista' | 'calendario')}
        options={[
          { value: 'lista', label: 'Lista' },
          { value: 'calendario', label: 'Calendário férias' },
        ]}
        aria-label='Visualização da equipe'
      />
    </GestorTabFiltersBar>
  )
}
